var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modal-component',{attrs:{"model_name":_vm.model_name}}),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('props-to-show-'+_vm.model_name),expression:"'props-to-show-'+model_name"}],attrs:{"variant":"primary"}},[_c('i',{staticClass:"icon-eye"}),_c('i',{staticClass:"icon-list p-l-10"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }